import { useMemo } from "react";

import useSearchParams, { UseSearchParamType } from "@/hooks/useSearchParams";
import { SearchFilter } from "@/types/SearchFilter";
import { deleteNil } from "@/utils";

/** This is wordy and ugly - BUT it keeps the useFilterParams hook to update unless
 * something that considers this was actually updated.
 *
 * For any prop that cannot be piped directly to the mentions API, use the useSearchParams hook.
 */
function useFilterParams(): UseSearchParamType<SearchFilter> {
  const [params, setParams] = useSearchParams<SearchFilter>();
  const filterParams: SearchFilter = useMemo(
    () =>
      deleteNil({
        channel_name: params.channel_name,
        search: params.search,
        tag: params.tag,
        channel_type: params.channel_type,
        freetext: params.freetext,
        language: params.language,
        sentiment: params.sentiment,
        end_date: params.end_date,
        start_date: params.start_date,
        min_reach_threshold: params.min_reach_threshold,
        mention_kind: params.mention_kind,
        page: params.page,
        p: params.p,
        sort_by: params.sort_by,
        insight_id: params.insight_id,
        insight_types: params.insight_types,
      }),
    [
      params.search,
      params.channel_name,
      params.tag,
      params.channel_type,
      params.freetext,
      params.language,
      params.sentiment,
      params.end_date,
      params.start_date,
      params.min_reach_threshold,
      params.mention_kind,
      params.page,
      params.p,
      params.sort_by,
      params.insight_id,
      params.insight_types,
    ]
  );
  return [filterParams, setParams];
}

export default useFilterParams;
